module.exports = __webpack_public_path__ + "static/media/USDC-ETH.9f0d88f1.png";